// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"7bcf5986","462":"f406880a","563":"ce575598","980":"099290b1"}[chunkId] + ".chunk.css";
};